import { FC, HTMLAttributes } from "react";

export interface IParagraphAttributes extends HTMLAttributes<HTMLParagraphElement> {
    text?: string
}

export const Paragraph: FC<IParagraphAttributes> = ({ text, children, ...props }) => {
    return <>
        <p {...props}>
            {text}
            {children}
        </p>
    </>
}